import React from "react";
import { NavLink } from "react-router-dom";
import * as DataServices from "../../api/DataServices";
// import { ReactComponent as Help } from "../../assets/images/dashboard/help.svg";
import { ReactComponent as Learn } from "../../assets/images/dashboard/learn.svg";
import { ReactComponent as NewVisit } from "../../assets/images/dashboard/newVisit.svg";
import { ReactComponent as TransactionList } from "../../assets/images/dashboard/transactionList.svg";
import { useUserState } from "../../providers/UserProvider";

// import HeaderItem from "./HeaderItem";
import { useTranslation } from "react-i18next";
import classes from "./index.module.scss";

function DashboardCmp() {
  const { t } = useTranslation();
  const user = useUserState();
  let userType = user?.user_login?.approve;
  let customUrl =
    DataServices.webConfig("info_site") + user?.user_login?.username;

  const renderDashboard = () => {
    if (userType === "doctor") {
      return (
        <>
          <NavLink to="/set-calendar" className={classes.flexItem}>
            <TransactionList />
            <span className={classes.Itemtexts}>
              {t("components.dashboard.mainContainer.doctor.workSchedule")}
            </span>
          </NavLink>
          <NavLink to="/set-calendar" className={classes.flexItem}>
            <Learn />
            <span className={classes.Itemtexts}>
              {t("components.dashboard.mainContainer.doctor.admissionNow")}
            </span>
          </NavLink>
          <a
            href={customUrl}
            target="_blank"
            rel="noopener noreferrer"
            className={classes.flexItem}
          >
            <NewVisit />
            <span className={classes.Itemtexts}>
              {t("components.dashboard.mainContainer.doctor.dedicatedPage")}
            </span>
          </a>
          <NavLink to="/transactions" className={classes.flexItem}>
            <TransactionList />
            <span className={classes.Itemtexts}>
              {t("components.dashboard.mainContainer.doctor.transactionList")}
            </span>
          </NavLink>
        </>
      );
    }

    if (userType === "user") {
      return (
        <>
          <NavLink to="/medical-history" className={classes.flexItem}>
            <TransactionList />
            <span className={classes.Itemtexts}>
              {t("components.dashboard.mainContainer.user.medicalRecord")}
            </span>
          </NavLink>
          <NavLink to="/profile" className={classes.flexItem}>
            <Learn />
            <span className={classes.Itemtexts}>
              {t("components.dashboard.mainContainer.user.myInformation")}
            </span>
          </NavLink>
          <a
            href="https://sbm24.com//search"
            target="_blank"
            className={classes.flexItem}
            rel="noreferrer"
          >
            <NewVisit />
            <span className={classes.Itemtexts}>
              {t("components.dashboard.mainContainer.user.makeNewAppointment")}
            </span>
          </a>
          <NavLink to="/patient-transactions" className={classes.flexItem}>
            <TransactionList />
            <span className={classes.Itemtexts}>
              {t("components.dashboard.mainContainer.user.transactionList")}
            </span>
          </NavLink>
        </>
      );
    }
  };

  return (
    <div className={classes.mainContainer}>
      {/* <HeaderItem /> */}
      {renderDashboard()}
    </div>
  );
}

export default DashboardCmp;
